<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="330px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Send SMS & Email</span>
        </div>
        <div class="dialog-body">
          <el-form
            ref="send-form"
            :rules="rules"
            :model="sendFormData">
            <!--            <template  v-if="!isQuote||isQuote&&contactType==3">-->
            <!--              <div-->
            <!--                class="form-item">-->
            <!--                <span :class="{'mg-l-28':!isQuote}">Company Email</span>-->
            <!--                <el-form-item >-->
            <!--                  <div class="flex-align-center">-->
            <!--                    <v-checkbox-->
            <!--                      v-if="!isQuote"-->
            <!--                      v-model="sendFormData.email_send"-->
            <!--                      :is-boolean="false"-->
            <!--                      class="mg-r-16"></v-checkbox>-->
            <!--                    <v-input-->
            <!--                      v-model="form.email"-->
            <!--                      disabled-->
            <!--                    />-->
            <!--                  </div>-->
            <!--                </el-form-item>-->

            <!--              </div>-->
            <!--              <div class="form-item" >-->
            <!--                <el-form-item-->
            <!--                  prop="email_send_content"-->
            <!--                  :rules="rules.input">-->
            <!--                  <v-input-->
            <!--                    v-model="sendFormData.email_send_content"-->
            <!--                    type="textarea"-->
            <!--                    :disabled="isQuote?false:sendFormData.email_send==0"-->
            <!--                    :rows="4" />-->
            <!--                </el-form-item>-->
            <!--              </div>-->
            <!--            </template>-->
            <template>
              <div class="form-item">
                <span>Referrer</span>
                <el-form-item >
                  <div class="flex-align-center">
                    <!--                    <v-checkbox-->
                    <!--                      v-if="!isQuote"-->
                    <!--                      v-model="sendFormData.referrer_send"-->
                    <!--                      :is-boolean="false"-->
                    <!--                      class="mg-r-16"></v-checkbox>-->
                    <v-input
                      :value="referSendValue"
                      disabled
                    />
                  </div>
                </el-form-item>

              </div>
              <div class="form-item">
                <el-form-item
                  prop="referrer_send_content"
                  :rules="rules.input">
                  <v-input
                    v-model="sendFormData.referrer_send_content"
                    :disabled="sendFormData.referrer_send==0"
                    type="textarea"
                    :rows="4" />
                </el-form-item>
              </div>
            </template>
            <!--            <template  v-if="!isQuote||isQuote&&contactType==1">-->
            <!--              <div class="form-item">-->
            <!--                <span   :class="{'mg-l-28':!isQuote}">Contact Person</span>-->
            <!--                <div class="flex-align-center">-->

            <!--                  <v-checkbox-->
            <!--                    v-if="!isQuote"-->
            <!--                    v-model="sendFormData.contact_phone_send"-->
            <!--                    :is-boolean="false"-->
            <!--                    class="mg-r-16"></v-checkbox>-->
            <!--                  <el-form-item-->
            <!--                  >-->
            <!--                    <v-input-->
            <!--                      :value="contact_phone"-->
            <!--                      maxlength="8"-->
            <!--                      disabled-->
            <!--                      keyNumber-->
            <!--                    />-->
            <!--                  </el-form-item>-->
            <!--                </div>-->


            <!--              </div>-->
            <!--              <div class="form-item">-->
            <!--                <el-form-item-->
            <!--                  prop="contact_phone_send_content"-->
            <!--                  :rules="rules.input">-->
            <!--                  <v-input-->
            <!--                    v-model="sendFormData.contact_phone_send_content"-->
            <!--                    type="textarea"-->
            <!--                    :disabled="isQuote?false:sendFormData.contact_phone_send==0"-->
            <!--                    :rows="4" />-->
            <!--                </el-form-item>-->
            <!--              </div>-->
            <!--            </template>-->
          </el-form>
          <div class="flex-sb-center">
            <div>
              <v-button
                gray
                @click="onCancel">Cancel</v-button>
            </div>
            <div>
              <v-button
                gray
                @click="onSkip">Skip</v-button>
              <v-button
                green
                :disabled="disableSend"
                @click="onSend">Send</v-button>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import {sendSMEPayment} from '@api/new_sme'
export default {
  name: 'SendEmailSmsDialog',
  mixins: [MixinRules,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    contactType: {
      type: [String, Number],
      default: ''
    },
    initContent: {
      type: String,
      default: ''
    },
    skip: {
      type: Boolean,
      default: true
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    isFormTicket: {
      type: Boolean,
      default: false
    },
    isPayment: {
      type: Boolean,
      default: false
    },
    updateContent: {
      type: Boolean,
      default: false
    },
    value:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        email_send:0,
        email_send_content:'',
        contact_phone_send:0,
        contact_phone_send_content:'',
        referrer_send:1,
        referrer_send_content:'',
        // contact_phone:'',
      }
    }
  },
  computed: {
    referrer(){
      let {referrer} = this.form||{}
      return referrer||''
    },
    ticketId(){
      let {ticket_id} = this.form||{}
      if(this.isQuote||this.isFormTicket)
        return ticket_id||''
      return this.$route.query.ticket_id
    },
    referSendValue(){
      let {isrd_nm,send_mobile} = this.referrer||{}
      return `${isrd_nm} - ${send_mobile}`
    },
    send_message(){
      let {send_message,send_sign_message} = this.form||{}
      if(this.isPayment)
        return send_sign_message||{}
      return send_message||{}
    },
    contact_phone(){
      let {contact_phone} = this.form||{}
      return contact_phone||{}
    },
    disableSend(){
      let {email_send,contact_phone_send,referrer_send} = this.sendFormData||{}
      if(this.isQuote)
        return false
      return !email_send&&!contact_phone_send&&!referrer_send
    }
  },
  watch: {
    send_message: {
      immediate: true,
      handler(val, old) {
        let{email_data,contact_data,referrer_data} = val||{}
        this.sendFormData.referrer_send_content = referrer_data
        this.sendFormData.email_send_content = email_data
        this.sendFormData.contact_phone_send_content = contact_data
      }
    },
    value:{
      immediate: false,
      handler(val) {
        this.dialog = val
        if(val){
          // this.sendFormData.contact_phone = this.contact_phone
        }
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('input',false)
      this.dialog = false
    },
    onSend() {
      this.$refs['send-form'].validate(async (valid, rules) => {
        if(valid) {
          if(this.isPayment){
            this.$emit('input',false)
            this.$emit('send',this.sendFormData)
            return
          }
          await this.network().sendSMEPayment(this.sendFormData)
          this.dialog = false
          this.$emit('input',false)
          this.$emit('send', this.sendFormData)
        }
        else {
          console.log(rules)
        }
      })
    },
    async onSkip() {
      if(this.isPayment){
        this.$emit('input',false)
        this.$emit('skip',this.sendFormData)
        return
      }
      await this.network().sendSMEPayment(this.sendFormData)
      this.$emit('input',false)
      this.$emit('skip')
    },
    network(){
      return{
        sendSMEPayment:async (params)=>{
          // if(this.isQuote){
          //   params.contact_phone_send = this.contactType==1?1:0
          //   params.email_send = this.contactType==3?1:0
          // }
          let data = await sendSMEPayment({
            ...params,
            ticket_id:this.ticketId
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {

  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #1B1F23;
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .mg-l-28{
      margin-left: 28px;
    }
    .mg-r-16{
      margin-right: 16px;
    }
  }
  h3 {
    padding-bottom: 10px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    margin: 15px -15px -15px;
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
  }
  .form-item {
    & > span {
      font-weight: 600;
      font-size: 14px;
    }
  }
}
</style>
